import ajax from "../../lib/appfuse-react/core/ajax";

const courseAnnouncementService = {
    find: async ({predicate = '', sort = '', page, size}) => {
        const response = await ajax.get('courseClasses/findToPublish', { predicate, sort, page, size });
        const data = response.data;
        data.totalElements = response.totalElements;
        return data;
    },

    // 課程種類
    findCategories: async () => {
        const response = await ajax.get('courseCategories/findToPublish');
        return response.data;
    },
    // 課程名稱
    findCourses: async (options = {}) => {
        const { predicate = '', sort = '', page, size } = options;
        const response = await ajax.get("courseTitles", { predicate, sort, page, size });
        const data = response.data;
        data.totalElements = response.totalElements;
        return data;
    },
    // 課程內容
    getClassContent: async (url) => {
        const response = await ajax.get(url);
        return response.data;
    },
}

export default courseAnnouncementService;